var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Api } from "lavva.exalushome";
import { DataFrame, Method, Status } from "lavva.exalushome/build/js/DataFrame";
import { ExalusConnectionService } from "lavva.exalushome/build/js/Services/ExalusConnectionService";
import { ResponseResult } from "lavva.exalushome/build/js/Services/FieldChangeResult";
import { LoggerService } from "lavva.exalushome/build/js/Services/Logging/LoggerService";
import { UpdatesProvider } from "lavva.exalushome/build/js/Services/Updates/UpdatesProvider";
import { ProviderType, UpdateInfo, UpdateTypes } from "lavva.exalushome/build/js/Services/Updates/IUpdatesProvider";
import { UpdateErrorCode, UpdateProgressInfo, UpdateStatus } from "lavva.exalushome/build/js/Services/Updates/IUpdatesService";
import { PortosService } from "../../Portos";
export class PortosRadioUpdatesProvider {
    constructor(extInfo, runtimeInfo) {
        this._apiVersion = extInfo.APIVersion;
        this._extenstionVersion = extInfo.ExtensionVersion;
        this._protocolExtGuid = extInfo.ExtensionGuid;
        this._runtimeInfo = runtimeInfo;
        this._logger = Api.Get(LoggerService.ServiceName);
        this._connection = Api.Get(ExalusConnectionService.ServiceName);
    }
    get AvailableExtensionVersion() {
        return this._extenstionVersion;
    }
    get AvailableApiVersion() {
        return this._apiVersion;
    }
    get ExtensionGuid() {
        return this._protocolExtGuid;
    }
    get ProtocolGuid() {
        return PortosService.PortosProtocolGuid;
    }
    get ProviderType() {
        return ProviderType.Controller;
    }
    GetUpdateProviderName() {
        return `${PortosRadioUpdatesProvider.ProviderName}_${this._apiVersion}_${this._extenstionVersion}`;
    }
    GetAvailableRadioUpdateAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            this._logger.Debug(PortosRadioUpdatesProvider.ProviderName, `Checking for Portos 433 MHz adio firmware upgrade...`);
            const hadrwareInf = yield Api.Get(UpdatesProvider.ServiceName).GetHardwareInfoAsync();
            if ((_a = hadrwareInf.GetAvailableHardware.first(hInfo => hInfo.DevicePath == "/proc")) === null || _a === void 0 ? void 0 : _a.DisplayName.contains("AM3352"))
                return new ResponseResult(UpdateErrorCode.UnsupportedDevice, `Cannot get available updates! This Portos module does not support updates.`);
            if (parseFloat(this._extenstionVersion) < 0.1200518) {
                return new ResponseResult(UpdateErrorCode.UnsupportedExtensionVersion, `Cannot get available updates! Portos 433 MHz extension is too old for upgrade. Version: ${this._extenstionVersion}`);
            }
            const result = yield ((_b = this._connection) === null || _b === void 0 ? void 0 : _b.SendAndWaitForResponseAsync(new GetRadioVersionRequest(), 8000, false));
            let radioVersion = 0.2;
            if (result != null && result.Data != null)
                radioVersion = result.Data;
            this._logger.Debug(PortosRadioUpdatesProvider.ProviderName, `Portos 433MHz radio firmware version: ${radioVersion}`);
            var url = `https://updates.tr7.pl/firmware/${this._runtimeInfo.UpdateChannel}/${radioVersion}/${PortosService.PortosRadioModuleDeviceGuid}`;
            try {
                this._logger.Debug(`Looking for update at: ${url}/${radioVersion}/update.json`);
                let response = yield fetch(`${url}/${radioVersion}/update.json`);
                let updateData;
                let updateInfo = new UpdateInfo();
                switch (response.status) {
                    case 200:
                        if (response.body != null)
                            updateData = (yield response.json());
                        break;
                    default:
                        this._logger.Debug(`Looking for update at: ${url}/update.json`);
                        response = yield fetch(`${url}/update.json`);
                        switch (response.status) {
                            case 200:
                                if (response.body != null)
                                    updateData = (yield response.json());
                                break;
                            case 404:
                                return new ResponseResult(UpdateErrorCode.DeviceIsUpToDate, `Updates not found, radio Portos 433MHz is already up-to-date.`);
                            default:
                                return new ResponseResult(UpdateErrorCode.CannotGetUpdates, `Response status code does not indicate success. Status: ${response.status}`);
                        }
                }
                if (updateData != null) {
                    updateData.UpdateType = UpdateTypes.RadioFirmware;
                    updateInfo.CurrentResourceVersion = radioVersion.toString();
                    updateInfo.UpdatedResourceName = "Radio Portos 433MHz";
                    updateInfo.UpdateDescription = new Map([["pl-PL", updateData.Description]]);
                    updateInfo.Update = updateData;
                    return updateInfo;
                }
                else
                    throw (new Error(`Cannot get Update Data from response. Status: ${response.status}`));
            }
            catch (err) {
                return new ResponseResult(UpdateErrorCode.CannotGetUpdates, `Cannot get available updates! ${err}`);
            }
        });
    }
    InstallRadioUpdateAsync(update, updateProgress, updateAction) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (updateAction != null)
                return new ResponseResult(UpdateErrorCode.UpdateActionsNotSupported, `Update service for given resource: ${update.UpdatedResourceName} does not support custom update actions.`);
            const progressInfo = new UpdateProgressInfo();
            progressInfo.UpdatedResourceName = new Map([["pl-PL", update.UpdatedResourceName], ["en-US", update.UpdatedResourceName]]);
            try {
                yield ((_a = this._connection) === null || _a === void 0 ? void 0 : _a.SendAndHandleResponseAsync(new UpgradeRadioFirmwareRequest(update.Update.DownloadUri), 12000, (resp) => {
                    switch (resp.Status) {
                        case Status.MultiDataResponseStart:
                            progressInfo.Status = UpdateStatus.PreparingForUpgrade;
                            break;
                        case Status.MultiDataResponse:
                            if (resp.Data == null) {
                                this._logger.Warning(PortosRadioUpdatesProvider.ProviderName, `Recived update response without data! URI: ${update.Update.DownloadUri}`);
                                return;
                            }
                            progressInfo.Percentage = resp.Data;
                            progressInfo.Status = UpdateStatus.Upgrading;
                            break;
                        case Status.MultiDataResponseStop:
                            if (resp.Data) {
                                progressInfo.Percentage = 100;
                                progressInfo.Status = UpdateStatus.Upgraded;
                            }
                            else
                                progressInfo.Status = UpdateStatus.InstallationError;
                            break;
                    }
                    this._logger.Debug(PortosRadioUpdatesProvider.ProviderName, `Recived update progress response, percentage: ${progressInfo.Percentage}, status: ${progressInfo.Status}, resource name: ${update.UpdatedResourceName}`);
                    updateProgress(progressInfo);
                }, false));
            }
            catch (error) {
                progressInfo.Percentage = 0;
                progressInfo.Status = UpdateStatus.Error;
                updateProgress(progressInfo);
                return new ResponseResult(UpdateErrorCode.CannotProcessUpdate, `Cannot process update, error: ${error}`);
            }
            return Status.OK;
        });
    }
    GetCurrentRadioVersionAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const result = yield ((_a = this._connection) === null || _a === void 0 ? void 0 : _a.SendAndWaitForResponseAsync(new GetRadioVersionRequest(), 8000, false));
            if (result != null && result.Data != null)
                return result.Data.toString();
            return "n/a";
        });
    }
}
PortosRadioUpdatesProvider.ProviderName = "PortosControllerUpdateProvider";
class GetRadioVersionRequest extends DataFrame {
    constructor() {
        super();
        this.Resource = "/portos/radio/version";
        this.Method = Method.Get;
    }
}
class UpgradeRadioFirmwareRequest extends DataFrame {
    constructor(uri) {
        super();
        this.Resource = "/portos/radio/upgrade";
        this.Method = Method.Put;
        this.Data = uri;
    }
}
//# sourceMappingURL=PortosRadioUpdatesProvider.js.map